import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject, uploadBytesResumable } from 'firebase/storage';

// Firebase configuration based on environment
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAAk19tR6ZS4d0ZcnZM5qOJCAP3PqmG18w",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "smata1.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "smata1",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "smata1.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "571809180629",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:571809180629:web:c9275f2596dc8300526b5c"
};

console.log('Firebase config:', {
  ...firebaseConfig,
  apiKey: firebaseConfig.apiKey ? '***' : undefined
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);
console.log('Firebase app initialized');

const auth = getAuth(app);
console.log('Firebase auth initialized');

const db = getFirestore(app);
console.log('Firebase Firestore initialized');

export const storage = getStorage(app);
console.log('Firebase Storage initialized');

// Set language preference
auth.useDeviceLanguage();

// Utility function to upload a file to Firebase Storage
export const uploadFile = async (
  file: File,
  userId: string,
  bookId: string,
  setUploadProgress?: (progress: number) => void
): Promise<string> => {
  const fileExtension = file.name.split('.').pop();
  const storageRef = ref(storage, `books/${userId}/${bookId}.${fileExtension}`);

  console.log('Uploading file:', {
    fileName: file.name,
    fileSize: file.size,
    userId,
    bookId,
    storagePath: `books/${userId}/${bookId}.${fileExtension}`
  });

  try {
    // Use simple uploadBytes for now to avoid resumable upload issues
    const snapshot = await uploadBytes(storageRef, file);
    console.log('Upload successful:', snapshot);
    
    if (setUploadProgress) {
      setUploadProgress(100);
    }
    
    const downloadURL = await getDownloadURL(snapshot.ref);
    console.log('Download URL:', downloadURL);
    return downloadURL;
  } catch (error) {
    console.error('Error uploading file:', error);
    console.error('Error details:', {
      code: error instanceof Error ? error.message : 'Unknown error',
      message: error instanceof Error ? error.message : 'Unknown error',
      serverResponse: error
    });
    throw error;
  }
};

// Utility function to delete a file from Firebase Storage
export const deleteFile = async (fileUrl: string): Promise<void> => {
  try {
    const fileRef = ref(storage, fileUrl);
    await deleteObject(fileRef);
  } catch (error) {
    console.error('Error deleting file:', error);
    throw error;
  }
};

export { auth, db }; 